import { api, unwrap } from "./httpClient";
import type { TradingBotConfig } from "../types/api";

export interface ListClientConfigsResult {
  configs: TradingBotConfig[];
  maxTradingBots: number;
}

export const listClientConfigs = async (userId: number): Promise<ListClientConfigsResult> => {
  const response = await api<{ configs: TradingBotConfig[]; maxTradingBots: number }>({
    method: "GET",
    url: `/admin/users/${userId}/trading-bot`,
  });
  const data = response.data.data;
  return {
    configs: data?.configs ?? [],
    maxTradingBots: data?.maxTradingBots ?? 1,
  };
};

export const updateClientConfigEnabled = async (
  userId: number,
  configId: number,
  enabled: boolean
) =>
  unwrap<{ config: TradingBotConfig }>(
    api({
      method: "PATCH",
      url: `/admin/users/${userId}/trading-bot/${configId}`,
      data: { enabled },
    })
  );

/** Met à jour le nombre max de robots pour un client (admin ou manager du client). */
export const updateClientMaxTradingBots = async (
  userId: number,
  maxTradingBots: number
) =>
  unwrap<{ maxTradingBots: number }>(
    api({
      method: "PATCH",
      url: `/admin/users/${userId}/max-trading-bots`,
      data: { maxTradingBots },
    })
  );
